import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faArrowLeft,
    faArrowRight, faBoltLightning,
    faChain,
    faChild, faClock,
    faCogs, faCoins, faFlag,
    faGamepad,
    faHashtag,
    faGlobe,
    faKey,
    faList,
    faPlay,
    faRefresh,
    faSignature,
    faSquare,
    faSquareCheck,
    faUserSecret,
    faLock,
    faLockOpen,
    faAngleDown
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faCogs,
    faArrowRight,
    faArrowLeft,
    faGlobe,
    faGamepad,
    faChain,
    faChild,
    faFlag,
    faCoins,
    faPlay,
    faSignature,
    faKey,
    faClock,
    faBoltLightning,
    faSquareCheck,
    faSquare,
    faList,
    faLock,
    faLockOpen,
    faRefresh,
    faUserSecret,
    faHashtag,
    faAngleDown
);
